var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGoogleDrive = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#google_drive_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0066DA",
  d: "m2.058 12.466.618 1.067c.128.224.313.4.529.529l2.205-3.817H1c0 .249.064.497.192.722l.866 1.5Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00AC47",
  d: "M8 5.755 5.795 1.938c-.217.128-.401.305-.53.53L1.193 9.523c-.125.22-.192.468-.192.721h4.41L8 5.755Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EA4335",
  d: "M12.795 14.062c.216-.128.4-.305.529-.53l.257-.44 1.226-2.125c.129-.225.193-.473.193-.722h-4.41l.938 1.844 1.267 1.973Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00832D",
  d: "m8 5.755 2.205-3.817a1.41 1.41 0 0 0-.722-.192H6.517c-.257 0-.506.072-.722.192L8 5.755Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2684FC",
  d: "M10.59 10.245H5.41l-2.205 3.817c.217.128.465.192.722.192h8.146c.257 0 .505-.072.722-.192l-2.205-3.817Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFBA00",
  d: "m12.77 5.995-2.036-3.528a1.455 1.455 0 0 0-.529-.529L8 5.755l2.59 4.49h4.402c0-.248-.064-.497-.193-.721l-2.028-3.529Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "google_drive_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M1 1.746h14v12.509H1z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGoogleDrive);
export default ForwardRef;